import { ProgressValues } from '@pc/progress-step-indicator';
import { TravelerSteps } from './traveller-steps';

export const travellerStepProgressMap = {
  [TravelerSteps.Traveler]: ProgressValues.Ten,
  [TravelerSteps.HealthScreening]: ProgressValues.Fifty,
  [TravelerSteps.MedicalAssessment]: ProgressValues.Seventy
};

export const travellerFragmentsProgressMap = {
  [TravelerSteps.Traveler]: 'travellers',
  [TravelerSteps.HealthScreening]: 'health',
  [TravelerSteps.MedicalAssessment]: 'medical'
};
